import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import api from 'core/interceptors/api';
import { ServerBaseUrlForStaticImages } from 'constants';
import { FormControl, InputLabel, Select, MenuItem, IconButton, InputAdornment, Box, Card, CardMedia } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar"; // Keeping for other snackbar messages
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/system";
import VendorProfileWithCompletion from './vendor_profile_completion';
import KeywordsInput from '../Product_Details/KeywordsInput';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Lottie from "lottie-react";
import profileIncompleteAnimation from "assets/images/animation.json";
import LogoutButton from "layouts/logout";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDTypography from "components/MDTypography";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SignatureCanvas from 'react-signature-canvas';



import {
    validateDropdown,
    validateGSTNumber,
    validateOwnerNameOptional,
    validateBusinessNameOptional,
    validateMobileNumberOptional,
    validateBankAccountNumberOptional,
    validateIFSCCodeOptional,
    validateAadharNumberOptional,
    validatePanCardNumberOptional,
    validateNameOptional
} from '../validations';


const VendorUserProfile = () => {
    const [location, setLocation] = useState({ latitude: "", longitude: "", place: "" });
    const navigate = useNavigate();
    const [isFetchingLocation, setIsFetchingLocation] = useState(false);
    const [isSavingProfile, setIsSavingProfile] = useState(false);
    const [businessCategoryOptions, setBusinessCategoryOptions] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [Input, setInput] = useState({});
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [previewUrls, setPreviewUrls] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [completion, setCompletion] = useState(0);

    const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
    const signaturePadRef = useRef(null);

    // No longer using showCompletionSuccessSnackbar for a pop-up.
    // Instead, we will use a local state to control the visibility of the on-screen banner.
    const [show100PercentCompleteBanner, setShow100PercentCompleteBanner] = useState(false);

    const dataURLtoBlob = (dataUrl) => {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };
    const StyledTabs = styled(Tabs)({
        display: "flex",
        justifyContent: "center",
        width: "100%",
        "& .MuiTabs-indicator": { backgroundColor: "#0288d1", height: 4, borderRadius: 2 },
        "& .MuiTab-root": {
            fontWeight: "bold",
            color: "#666",
            textTransform: "capitalize",
            fontSize: 16,
            transition: "0.3s",
            "&:hover": { color: "#0288d1" },
        },
        "& .Mui-selected": { color: "#0288d1" },
    });

    const StyledCard = styled(Card)({
        width: "100%",
        padding: 16,
        borderRadius: 12,
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "0.3s",
        "&:hover": { transform: "scale(1.03)" },
    });

    const [profileData, setProfileData] = useState({
        businessName: '',
        ownerName: '',
        email: '',
        businessType: '',
        mobileNumber: '',
        accountNo: '',
        ifscCode: '',
        passbookName: '',
        aadharNumber: '',
        panCardNumber: '',
        gst: '',
        logo: null,
        signaturePhoto: null,
        gpay: '',
        phonepe: '',
        paytm: '',
        upiId: '',
        alternativeMobileNumber: '',
        currentLocation: '',
        keywords: '',
        latitude: '',
        longitude: '',
        branchName: '',
        bankName: '',
        vendorPhoto: null,
        shopPhoto: null,
        sgoGpsPhoto: null,
        qrCode: null,
        msmCertificate: null,
        description: '',
        approvedStatus: '',
        status: '',
        reasonForNotApproved: '',
        businessCategory: '',
        userProofDoc: [],
    });

    const email = localStorage.getItem("email");

    const fetchBusinessCategory = useCallback(async () => {
        try {
            const response = await api.get("/vendor_management/business_category");
            if (response.data.success) {
                const categories = response.data.business_catgory;
                if (Array.isArray(categories)) {
                    const filteredCategories = categories.filter(category => category !== null && category !== undefined);
                    setBusinessCategoryOptions(filteredCategories);
                } else {
                    console.error("API response for business categories 'business_catgory' is not an array:", categories);
                    setBusinessCategoryOptions([]);
                }
            } else {
                console.error("API call for business categories reported success: false. Message:", response.data.message);
                setBusinessCategoryOptions([]);
            }
        } catch (error) {
            console.error("Error fetching business categories from API:", error);
            setBusinessCategoryOptions([]);
        }
    }, []);

    const fetchCompletion = useCallback(async () => {
        try {
            const res = await api.get(`/vendor_register/profile-completion/${email}`);
            const percent = parseFloat(res.data.profile_completion.replace("%", ""));
            setCompletion(percent);
            console.log("DEBUG: Fetched completion:", percent);
        } catch (error) {
            console.error("Failed to fetch profile completion:", error);
        }
    }, [email]);

    const fetchVendorProfile = useCallback((userEmail, setProfileDataCallback) => {
        api.get(`/vendor_register/fetch_approved_by_email?email=${userEmail}`)
            .then(response => {
                const vendor = response.data.vendor;
                if (vendor) {
                    setProfileDataCallback({
                        businessName: vendor.business_name || '',
                        ownerName: vendor.owner_name || '',
                        email: vendor.email || '',
                        businessType: vendor.business_type || '',
                        mobileNumber: vendor.mobile_number || '',
                        accountNo: vendor.account_number || '',
                        ifscCode: vendor.ifsc_code || '',
                        passbookName: vendor.passbook_name || '',
                        aadharNumber: vendor.aadhar_number || '',
                        panCardNumber: vendor.pan_card_number || '',
                        gst: vendor.gst || '',
                        logo: vendor.logo || null,
                        signaturePhoto: vendor.signature_photo || null,
                        gpay: vendor.gpay || '',
                        phonepe: vendor.phonepe || '',
                        paytm: vendor.paytm || '',
                        upiId: vendor.upi_id || '',
                        alternativeMobileNumber: vendor.alternative_number || '',
                        currentLocation: vendor.current_location || '',
                        keywords: vendor.keywords || '',
                        latitude: vendor.latitude || '',
                        longitude: vendor.longitude || '',
                        branchName: vendor.branch_name || '',
                        bankName: vendor.bank_name || '',
                        vendorPhoto: vendor.vendor_photo || null,
                        shopPhoto: vendor.shop_photo || null,
                        sgoGpsPhoto: vendor.sgo_gps_photo || null,
                        qrCode: vendor.qr_code || null,
                        msmCertificate: vendor.msm_certificate || null,
                        description: vendor.description || '',
                        approvedStatus: vendor.approved_status || '',
                        status: vendor.status || '',
                        reasonForNotApproved: vendor.reason_for_not_approved || '',
                        businessCategory: vendor.business_category || '',
                        userProofDoc: Array.isArray(vendor.user_proof_doc) ? vendor.user_proof_doc.filter(Boolean) : (vendor.user_proof_doc ? vendor.user_proof_doc.split(',').filter(Boolean) : []),
                    });
                }
            })
            .catch(error => {
                console.error('There was an error fetching the profile data!', error);
            });
    }, []);

    useEffect(() => {
        if (email) {
            fetchBusinessCategory();
            fetchVendorProfile(email, setProfileData);
            fetchCompletion();
        }
    }, [email, fetchVendorProfile, fetchCompletion, fetchBusinessCategory]);

    // --- REVISED LOGIC FOR 100% COMPLETION BANNER (NO AUTO-RELOAD/POP-UP) ---
    useEffect(() => {
        // This localStorage flag tracks if the 100% completion banner has been shown
        // and if the profile has consistently remained at 100% since that point.
        const hasBeen100PercentNotified = localStorage.getItem("hasBeen100PercentNotified") === "true";

        console.log("DEBUG: useEffect [completion] run. Current completion:", completion, "hasBeen100PercentNotified in LS:", hasBeen100PercentNotified);

        if (completion === 100) {
            // If profile is 100%, show the banner
            setShow100PercentCompleteBanner(true);
            // And mark that we've notified the user for 100% completion
            localStorage.setItem("hasBeen100PercentNotified", "true");
            // Also ensure the incomplete profile banner is dismissed if the profile is 100%
            localStorage.setItem("completionReminderDismissed", "false");
            console.log("DEBUG: Profile is 100%. Showing complete banner and setting localStorage flag.");
        } else {
            // If completion is less than 100%
            setShow100PercentCompleteBanner(false); // Hide the 100% complete banner

            // If the profile completion was previously 100% and now dropped below,
            // reset the localStorage flag so it can notify again if it reaches 100% later.
            if (hasBeen100PercentNotified) {
                localStorage.setItem("hasBeen100PercentNotified", "false");
                console.log("DEBUG: Completion dropped below 100%, resetting 'hasBeen100PercentNotified' in LS.");
            }
        }
    }, [completion]); // Dependency array: re-run when completion changes


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prevData) => ({ ...prevData, [name]: value }));

        let error = "";
        switch (name) {
            case "businessName":
                error = validateBusinessNameOptional(value);
                break;
            case "ownerName":
                error = validateOwnerNameOptional(value);
                break;
            case "alternativeMobileNumber":
                error = validateMobileNumberOptional(value);
                break;
            case "accountNo":
                error = validateBankAccountNumberOptional(value);
                break;
            case "ifscCode":
                error = validateIFSCCodeOptional(value);
                break;
            case "aadharNumber":
                error = validateAadharNumberOptional(value);
                break;
            case "panCardNumber":
                error = validatePanCardNumberOptional(value);
                break;
            case "gst":
                error = validateGSTNumber(value);
                break;
            case "businessCategory":
                error = validateDropdown("Business Category", value);
                if (value !== "Others") {
                    setInput((prev) => ({ ...prev, others: "" }));
                    setValidationErrors((prevErrors) => ({ ...prevErrors, others: "" }));
                }
                break;
            case "branchName":
            case "bankName":
            case "passbookName":
            case "description":
                return validateNameOptional(value);
            default:
                error = "";
        }
        setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    };

    const handleGetLocation = () => {
        setIsFetchingLocation(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;

                    console.log("Geolocation Accuracy (meters):", position.coords.accuracy);

                    try {
                        const response = await fetch(
                            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
                        );
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        const data = await response.json();
                        const placeName = data.display_name || "Location not found";

                        setIsFetchingLocation(false);
                        setLocation({ latitude, longitude, place: placeName });
                        setProfileData((prevData) => ({
                            ...prevData,
                            currentLocation: placeName,
                            latitude: latitude.toString(),
                            longitude: longitude.toString(),
                        }));
                        setSnackbar({ open: true, message: "Location fetched successfully!", severity: "success" });
                    } catch (error) {
                        console.error("Error fetching place name (reverse geocoding):", error);
                        setIsFetchingLocation(false);
                        setLocation({ latitude: "", longitude: "", place: "Unknown location" });
                        setProfileData((prevData) => ({
                            ...prevData,
                            currentLocation: "Error fetching location",
                            latitude: "",
                            longitude: "",
                        }));
                        setSnackbar({ open: true, message: "Failed to resolve location name.", severity: "error" });
                    }
                },
                (error) => {
                    console.error("Error fetching location (Geolocation API):", error);
                    setIsFetchingLocation(false);
                    setLocation({ latitude: "", longitude: "", place: "" });
                    setProfileData((prevData) => ({
                        ...prevData,
                        currentLocation: "Location access denied or unavailable",
                        latitude: "",
                        longitude: "",
                    }));

                    let errorMessage = "An unexpected error occurred while getting your location.";
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "Location permission denied. Please enable location services for this site.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "Location information is unavailable. Please ensure your device's location services are enabled.";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "Getting your location timed out. Please try again or check your internet connection.";
                            break;
                        case error.UNKNOWN_ERROR:
                            errorMessage = "An unknown error occurred while trying to get your location.";
                            break;
                    }
                    setSnackbar({ open: true, message: errorMessage, severity: "error" });
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                }
            );
        } else {
            console.error("Geolocation is not supported by this browser.");
            setIsFetchingLocation(false);
            setSnackbar({ open: true, message: "Your browser does not support Geolocation.", severity: "error" });
        }
    };

    const handleFileChange = (event, field) => {
        const file = event.target.files[0];
        if (!file) return;

        const maxSize = 2 * 1024 * 1024; // 2MB
        if (file.size > maxSize) {
            setSnackbar({ open: true, message: "Image size should not exceed 2MB.", severity: "error" });
            event.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewUrls((prev) => ({
                ...prev,
                [field]: reader.result,
            }));
            setSelectedFiles((prev) => ({
                ...prev,
                [field]: file,
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleUpload = async (field) => {
        if (!selectedFiles[field]) {
            setSnackbar({ open: true, message: "No file selected for upload!", severity: "error" });
            return;
        }

        const formData = new FormData();
        formData.append("email", profileData.email);
        formData.append("field_name", field);
        formData.append(field, selectedFiles[field]);

        try {
            const response = await api.post("/vendor_register/update_vendor_image", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === 1) {
                setSnackbar({ open: true, message: "Image uploaded successfully!", severity: "success" });
                fetchVendorProfile(email, setProfileData);
                fetchCompletion();
                setSelectedFiles((prev) => {
                    const newSelectedFiles = { ...prev };
                    delete newSelectedFiles[field];
                    return newSelectedFiles;
                });
                setPreviewUrls((prev) => {
                    const newPreviewUrls = { ...prev };
                    delete newPreviewUrls[field];
                    return newPreviewUrls;
                });
            } else {
                setSnackbar({ open: true, message: "Failed to upload file!", severity: "error" });
            }
        } catch (error) {
            console.error("Upload Error:", error);
            setSnackbar({ open: true, message: "Failed to upload file due to a server error.", severity: "error" });
        }
    };

    const handleAddImage = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if ((profileData.userProofDoc?.length || 0) >= 2) {
            setSnackbar({ open: true, message: "Only 2 government proof images are allowed.", severity: "warning" });
            event.target.value = '';
            return;
        }

        const maxSize = 2 * 1024 * 1024; // 2MB
        if (file.size > maxSize) {
            setSnackbar({ open: true, message: "Image size should not exceed 2MB.", severity: "error" });
            event.target.value = '';
            return;
        }

        const formData = new FormData();
        formData.append("email", profileData.email);
        formData.append("field_name", "userProofDoc");
        formData.append("file", file);

        try {
            const response = await api.post("/vendor_register/add_vendor_image", formData);

            if (response.data.status === 1) {
                setProfileData((prevData) => ({
                    ...prevData,
                    userProofDoc: [...(prevData.userProofDoc || []), response.data.file_path],
                }));
                setSnackbar({ open: true, message: "Image uploaded successfully!", severity: "success" });
                fetchCompletion();
            } else {
                setSnackbar({ open: true, message: "Failed to upload image.", severity: "error" });
            }
        }
        catch (error) {
            console.error("Error adding image:", error);
            setSnackbar({ open: true, message: "An error occurred while uploading the image.", severity: "error" });
        }
        event.target.value = '';
    };

    const handleRemoveFile = async (index) => {
        const fileToRemove = profileData.userProofDoc[index];
        if (!fileToRemove) {
            setSnackbar({ open: true, message: "File not found for removal.", severity: "error" });
            return;
        }

        const formData = new FormData();
        formData.append("email", profileData.email);
        formData.append("field_name", "userProofDoc");
        formData.append("file_path", fileToRemove);

        try {
            const response = await api.post("/vendor_register/remove_vendor_images", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.status === 1) {
                setProfileData((prevData) => {
                    const updatedFiles = [...(prevData.userProofDoc || [])];
                    updatedFiles.splice(index, 1);
                    return { ...prevData, userProofDoc: updatedFiles };
                });
                setSnackbar({ open: true, message: "Image removed successfully!", severity: "success" });
                fetchCompletion();
            } else {
                setSnackbar({ open: true, message: "Failed to remove image!", severity: "error" });
            }
        } catch (error) {
            console.error("Error removing image:", error);
            setSnackbar({ open: true, message: "Error occurred while removing image.", severity: "error" });
        }
    };

    const handleSave = async () => {
        let currentErrors = {};
        let isValid = true;

        const fieldsToValidate = [
            "businessName", "ownerName", "alternativeMobileNumber",
            "accountNo", "ifscCode", "aadharNumber", "panCardNumber", "gst",
            "businessCategory", "branchName", "bankName", "passbookName", "description"
        ];

        fieldsToValidate.forEach(field => {
            const error = validateField(field, profileData[field]);
            if (error) {
                currentErrors[field] = error;
                isValid = false;
            }
        });

        if (profileData.businessCategory === "Others" && !Input.others?.trim()) {
            currentErrors.others = "Please specify the business category.";
            isValid = false;
        } else if (profileData.businessCategory === "Others" && Input.others?.trim()) {
            const otherError = validateNameOptional(Input.others.trim());
            if (otherError) {
                currentErrors.others = otherError;
                isValid = false;
            }
        }

        if (profileData.keywords && profileData.keywords.length > 0 && typeof profileData.keywords === 'string') {
            if (profileData.keywords.startsWith(',') || profileData.keywords.endsWith(',')) {
                currentErrors.keywords = "Keywords should not start or end with a comma.";
                isValid = false;
            }
        }


        setValidationErrors(currentErrors);

        if (!isValid) {
            setSnackbar({ open: true, message: "Please fix validation errors before saving.", severity: "error" });
            return;
        }

        if (!profileData.email) {
            setSnackbar({ open: true, message: "Email is required to save the profile.", severity: "error" });
            return;
        }

        setIsSavingProfile(true);

        let formData = new FormData();

        const nonImageFields = [
            "businessName", "ownerName", "email", "businessType", "mobileNumber",
            "accountNo", "ifscCode", "passbookName", "aadharNumber", "panCardNumber",
            "gst", "gpay", "phonepe", "paytm", "upiId", "alternativeMobileNumber",
            "branchName", "bankName", "currentLocation", "latitude", "longitude",
            "businessCategory", "keywords", "description"
        ];

        nonImageFields.forEach(field => {
            let value = profileData[field];
            if (field === "keywords" && Array.isArray(value)) {
                value = value.join(',');
            }
            if (field === "businessCategory" && value === "Others" && Input.others) {
                value = Input.others.trim();
            }
            formData.append(field, value !== undefined && value !== null ? value : "");
        });

        formData.append("details", profileData.description);

        try {
            const response = await api.post('/vendor_register/update_vendor_profile', formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (response.data.status === 1) {
                setSnackbar({ open: true, message: "Profile Data Updated!", severity: "success" });
                fetchVendorProfile(email, setProfileData);
                fetchCompletion(); // This will re-fetch completion and trigger the useEffect
            } else {
                setSnackbar({ open: true, message: response.data.message || "Failed to Update profile data!", severity: "error" });
            }
        } catch (error) {
            console.error("Error updating vendor profile:", error);
            setSnackbar({ open: true, message: "An error occurred while saving profile data.", severity: "error" });
        } finally {
            setIsSavingProfile(false);
        }
    };

    const validateField = (name, value) => {
        switch (name) {
            case "businessName": return validateBusinessNameOptional(value);
            case "ownerName": return validateOwnerNameOptional(value);
            case "alternativeMobileNumber": return validateMobileNumberOptional(value);
            case "accountNo": return validateBankAccountNumberOptional(value);
            case "ifscCode": return validateIFSCCodeOptional(value);
            case "aadharNumber": return validateAadharNumberOptional(value);
            case "panCardNumber": return validatePanCardNumberOptional(value);
            case "gst": return validateGSTNumber(value);
            case "businessCategory": return validateDropdown("Business Category", value);
            case "branchName":
            case "bankName":
            case "passbookName":
            case "description":
                return validateNameOptional(value);
            default: return "";
        }
    };


    return (
        <DashboardLayout>
            <MDBox display="flex" justifyContent="flex-end" alignItems="center">
                <LogoutButton
                    onLogout={() => {
                        navigate("/login");
                    }}
                />
            </MDBox>
            <DashboardNavbar />

            {/* Fixed Top Banner for Incomplete Profile */}
            {completion < 100 && (
                <MDBox
                    sx={{
                        mb: -3,
                        backgroundColor: '#fffbe6',
                        color: '#f57c00',
                        mt: 2,
                        p: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                        minHeight: '60px',
                        transform: 'translateY(0)',
                        transition: 'transform 0.3s ease-in-out',
                    }}
                >
                    <Box sx={{ width: 40, height: 40 }}>
                        <Lottie animationData={profileIncompleteAnimation} loop autoplay />
                    </Box>
                    <MDTypography variant="body1" fontWeight="medium" color="text">
                        Your profile is **{completion.toFixed(0)}%** complete. Please fill out all required fields!
                    </MDTypography>
                    {/* Removed the dismiss button as the user wants it to be fixed until 100% */}
                </MDBox>
            )}

            {/* NEW: On-screen banner for 100% profile completion */}
            {show100PercentCompleteBanner && (
                <MDBox
                    sx={{

                        backgroundColor: '#e6ffed', // Light green for success
                        color: '#1a5d2c', // Dark green text
                        p: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                        minHeight: '60px',
                        transform: 'translateY(0)',
                        transition: 'transform 0.3s ease-in-out',
                    }}
                >
                    <CheckCircleOutlineIcon sx={{ fontSize: 40, color: '#28a745' }} />
                    <MDTypography variant="h6" fontWeight="bold" color="text">
                        Your profile is 100% complete! All features are now unlocked. Refresh the page to see the changes.
                    </MDTypography>
                </MDBox>
            )}


            {/* Main content, adjust pt to avoid being hidden by fixed banners */}
            {/* Dynamic padding-top ensures content is not obscured by the fixed header when it's visible */}
            <MDBox pt={completion < 100 || show100PercentCompleteBanner ? '80px' : '30px'} m={1} >
                {/* Profile Picture Section at the Top */}
                <Grid container spacing={3} direction="row" alignItems="center" justifyContent="space-between">
                    {/* User Profile Title */}
                    <Grid item>
                        <Typography variant="h5" fontWeight="bold">
                            Vendor Profile
                        </Typography>
                    </Grid>

                    {/* Vendor Profile Completion Component */}
                    <Grid item >
                        <Box display="flex" justifyContent="center" >
                            <VendorProfileWithCompletion
                                size={80}
                                textSize="30px"
                                completion={completion}
                                progressColor="#FE9900"
                                textColor="#0F08B4"
                                trailColor="#CCCCCC"
                            />
                        </Box>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    {/* Text Fields */}
                    <Grid item xs={12}>
                        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: "8px", mb: 2, mt: 3 }}>
                            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                Basic Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Business Name"
                                        name="businessName"
                                        value={profileData.businessName}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.businessName}
                                        helperText={validationErrors.businessName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Business Type</InputLabel>
                                        <Select
                                            name="businessType"
                                            label="Business Type"
                                            value={profileData.businessType}
                                            onChange={handleInputChange}
                                            sx={{ height: "56px" }}
                                            disabled // This field is disabled as per original code
                                        >
                                            <MenuItem value="Retail">Retail</MenuItem>
                                            <MenuItem value="Wholesale">Wholesale</MenuItem>
                                            <MenuItem value="Retail & Wholesale">Retail & Wholesale</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {/* Business Category dropdown */}
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth error={!!validationErrors.businessCategory}>
                                        <InputLabel id="business-category-label">Business Category</InputLabel>
                                        <Select
                                            labelId="business-category-label"
                                            name="businessCategory"
                                            label="Business Category"
                                            value={profileData.businessCategory || ""}
                                            onChange={handleInputChange}
                                            sx={{ height: "56px" }}
                                        >
                                            <MenuItem value="">Select Category</MenuItem>
                                            {businessCategoryOptions.length > 0 ? (
                                                businessCategoryOptions.map((type) => (
                                                    // Ensure 'type' and its properties are valid
                                                    type && type.id && type.business_category ? (
                                                        <MenuItem key={type.id} value={type.business_category}>
                                                            {type.business_category}
                                                        </MenuItem>
                                                    ) : null // Render nothing if item is invalid
                                                ))
                                            ) : (
                                                <MenuItem disabled>No Business Category Available</MenuItem>
                                            )}
                                            <MenuItem value="Others">Others</MenuItem>
                                        </Select>
                                        {validationErrors.businessCategory && (
                                            <MDTypography variant="caption" color="error">
                                                {validationErrors.businessCategory}
                                            </MDTypography>
                                        )}
                                    </FormControl>
                                </Grid>

                                {/* Other Business Category input if "Others" is selected */}
                                {profileData.businessCategory === "Others" && (
                                    <Grid item xs={12} sm={6}>
                                        <MDBox margin="normal" fullWidth>
                                            <TextField
                                                id="business_category_others"
                                                type="text"
                                                label="Specify Other Category"
                                                variant="outlined"
                                                name="others"
                                                value={Input.others || ""}
                                                onChange={(e) => {
                                                    setInput((prev) => ({ ...prev, others: e.target.value }));
                                                    // Also validate this field
                                                    setValidationErrors((prevErrors) => ({ ...prevErrors, others: validateNameOptional(e.target.value) }));
                                                }}
                                                fullWidth
                                                error={!!validationErrors.others}
                                                helperText={validationErrors.others}
                                            />
                                        </MDBox>
                                    </Grid>
                                )}

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Owner Name"
                                        name="ownerName"
                                        value={profileData.ownerName}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.ownerName}
                                        helperText={validationErrors.ownerName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Email"
                                        name="email"
                                        value={profileData.email}
                                        onChange={handleInputChange}
                                        disabled // This field is disabled as per original code
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Mobile Number"
                                        name="mobileNumber"
                                        value={profileData.mobileNumber}
                                        onChange={handleInputChange}
                                        disabled // This field is disabled as per original code
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Alternative Mobile Number"
                                        name="alternativeMobileNumber"
                                        value={profileData.alternativeMobileNumber}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.alternativeMobileNumber}
                                        helperText={validationErrors.alternativeMobileNumber}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Current Location"
                                        name="currentLocation"
                                        value={profileData.currentLocation}
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={handleGetLocation} disabled={isFetchingLocation}>
                                                        {isFetchingLocation ? <CircularProgress size={24} /> : <MyLocationIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Description"
                                        name="description"
                                        value={profileData.description}
                                        onChange={handleInputChange}
                                        multiline
                                        rows={3}
                                        error={!!validationErrors.description}
                                        helperText={validationErrors.description}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <KeywordsInput
                                        keywords={profileData.keywords ? profileData.keywords.split(",") : []}
                                        onChange={(newKeywords) =>
                                            handleInputChange({ target: { name: "keywords", value: newKeywords.join(",") } })
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: "8px", mb: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                Bank Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Account Number"
                                        name="accountNo"
                                        value={profileData.accountNo}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.accountNo}
                                        helperText={validationErrors.accountNo}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="IFSC Code"
                                        name="ifscCode"
                                        value={profileData.ifscCode}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.ifscCode}
                                        helperText={validationErrors.ifscCode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Passbook Name"
                                        name="passbookName"
                                        value={profileData.passbookName}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.passbookName}
                                        helperText={validationErrors.passbookName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Bank Name"
                                        name="bankName"
                                        value={profileData.bankName}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.bankName}
                                        helperText={validationErrors.bankName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Branch Name"
                                        name="branchName"
                                        value={profileData.branchName}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.branchName}
                                        helperText={validationErrors.branchName}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: "8px", mb: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                Identity Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Aadhar Number"
                                        name="aadharNumber"
                                        value={profileData.aadharNumber}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.aadharNumber}
                                        helperText={validationErrors.aadharNumber}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="PAN Card Number"
                                        name="panCardNumber"
                                        value={profileData.panCardNumber}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.panCardNumber}
                                        helperText={validationErrors.panCardNumber}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="GST Number"
                                        name="gst"
                                        value={profileData.gst}
                                        onChange={handleInputChange}
                                        error={!!validationErrors.gst}
                                        helperText={validationErrors.gst}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: "8px", mb: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                                Payment Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Gpay Number"
                                        name="gpay"
                                        value={profileData.gpay}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Paytm Number"
                                        name="paytm"
                                        value={profileData.paytm}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Phonepe Number"
                                        name="phonepe"
                                        value={profileData.phonepe}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="UPI ID"
                                        name="upiId"
                                        value={profileData.upiId}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} mb={4}>
                        <MDBox display="flex" justifyContent="center" mt={2}>
                            <MDButton
                                variant="gradient"
                                color="info"
                                onClick={handleSave}
                                disabled={isSavingProfile} // Disable save button while saving
                            >
                                {isSavingProfile ? <CircularProgress size={24} color="inherit" /> : "Save Profile"}
                            </MDButton>
                        </MDBox>
                    </Grid>

                    {/* Image Upload/Management Tabs */}
                    <Grid container justifyContent="center" sx={{ width: "100%" }}>
                        <Grid item xs={12}>
                            <Box sx={{ width: "100%" }}>
                                <StyledTabs
                                    value={activeTab}
                                    onChange={(e, newValue) => setActiveTab(newValue)}
                                    centered
                                >
                                    <Tab label="Single Images" />
                                    <Tab label="Govt Proof" />
                                </StyledTabs>

                                <Box sx={{ mt: 4, width: "100%" }}>
                                    {/* Single Images Tab */}
                                    {activeTab === 0 && (
                                        <Grid container spacing={3} justifyContent="center">
                                            {[
                                                { field: "vendorPhoto", label: "Vendor Photo" },
                                                { field: "logo", label: "Logo" },
                                                { field: "shopPhoto", label: "Shop Photo" },
                                                { field: "sgoGpsPhoto", label: "Shop GPS Photo" },
                                                { field: "signaturePhoto", label: "Signature", isSignature: true },
                                                { field: "qrCode", label: "QR Code" },
                                                { field: "msmCertificate", label: "MSME Certificate" },
                                            ].map((item) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    md={3}
                                                    key={item.field}
                                                    display="flex"
                                                    flexDirection="column"
                                                    alignItems="center"
                                                >
                                                    <StyledCard>
                                                        <MDTypography variant="subtitle1" fontWeight="bold" mb={1}>
                                                            {item.label}
                                                        </MDTypography>

                                                        <CardMedia
                                                            component="img"
                                                            image={
                                                                previewUrls[item.field] ||
                                                                (profileData[item.field]
                                                                    ? `${ServerBaseUrlForStaticImages}/vendor_register/media/${profileData[item.field]}`
                                                                    : "https://via.placeholder.com/150?text=No+Image")
                                                            }
                                                            alt={item.label}
                                                            sx={{
                                                                width: "100%",
                                                                height: 150,
                                                                objectFit: "contain",
                                                                mb: 1,
                                                                borderRadius: 2,
                                                                border: "1px solid #eee",
                                                            }}
                                                        />

                                                        {/* Upload input for images */}
                                                        {!item.isSignature && (
                                                            <>
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                    id={item.field}
                                                                    onChange={(e) => handleFileChange(e, item.field)}
                                                                    accept="image/*"
                                                                />
                                                                <label htmlFor={item.field}>
                                                                    <MDButton
                                                                        component="span"
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        sx={{ mt: 1 }}
                                                                    >
                                                                        Choose File
                                                                    </MDButton>
                                                                </label>
                                                            </>
                                                        )}

                                                        {/* Signature draw button */}
                                                        {item.isSignature && (
                                                            <MDButton
                                                                variant="outlined"
                                                                color="primary"
                                                                sx={{ mt: 1 }}
                                                                onClick={() => setSignatureDialogOpen(true)}
                                                            >
                                                                Draw /Upload Signature
                                                            </MDButton>
                                                        )}

                                                        {/* Upload button */}
                                                        {selectedFiles[item.field] && (
                                                            <MDButton
                                                                variant="contained"
                                                                color="success"
                                                                onClick={() => handleUpload(item.field)}
                                                                sx={{ mt: 1 }}
                                                            >
                                                                Upload
                                                            </MDButton>
                                                        )}
                                                    </StyledCard>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )}

                                    {/* Government Proof Tab */}
                                    {activeTab === 1 && (
                                        <Grid container spacing={3} justifyContent="center">
                                            {(profileData.userProofDoc || []).map((file, index) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    md={3}
                                                    key={index}
                                                    display="flex"
                                                    flexDirection="column"
                                                    alignItems="center"
                                                >
                                                    <StyledCard>
                                                        <MDTypography variant="subtitle1" fontWeight="bold" mb={1}>
                                                            Govt Proof {index + 1}
                                                        </MDTypography>
                                                        <CardMedia
                                                            component="img"
                                                            image={`${ServerBaseUrlForStaticImages}/vendor_register/media/${file}`}
                                                            alt={`Govt Proof ${index + 1}`}
                                                            sx={{
                                                                width: "100%",
                                                                height: 150,
                                                                objectFit: "contain",
                                                                mb: 1,
                                                                borderRadius: 2,
                                                                border: "1px solid #eee",
                                                            }}
                                                        />
                                                        <MDButton
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleRemoveFile(index)}
                                                            sx={{ mt: 1 }}
                                                        >
                                                            Remove
                                                        </MDButton>
                                                    </StyledCard>
                                                </Grid>
                                            ))}

                                            {/* Add new govt proof */}
                                            {(profileData.userProofDoc?.length || 0) < 2 && (
                                                <Grid item xs={12} sm={6} md={3} display="flex" flexDirection="column" alignItems="center">
                                                    <StyledCard>
                                                        <MDTypography variant="subtitle1" fontWeight="bold" mb={1}>
                                                            Add Govt Proof
                                                        </MDTypography>
                                                        <input
                                                            type="file"
                                                            hidden
                                                            id="addUserProof"
                                                            onChange={handleAddImage}
                                                            accept="image/*"
                                                        />
                                                        <label htmlFor="addUserProof">
                                                            <MDButton component="span" variant="outlined" color="primary">
                                                                Choose File
                                                            </MDButton>
                                                        </label>
                                                    </StyledCard>
                                                </Grid>
                                            )}
                                        </Grid>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Signature Dialog (Draw or Upload) */}
                    <Dialog
                        open={signatureDialogOpen}
                        onClose={() => setSignatureDialogOpen(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle>Signature / Seal</DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>

                                {/* Preview Section */}
                                {previewUrls.signaturePhoto ? (
                                    <Box
                                        component="img"
                                        src={previewUrls.signaturePhoto}
                                        alt="Signature Preview"
                                        sx={{ width: 400, height: 200, border: "1px solid #ccc", borderRadius: 1, objectFit: "contain" }}
                                    />
                                ) : (
                                    <SignatureCanvas
                                        ref={signaturePadRef}
                                        canvasProps={{ width: 400, height: 200, className: "sigCanvas" }}
                                        backgroundColor="#f5f5f5"
                                    />
                                )}

                                {/* Upload from Device */}
                                <input
                                    type="file"
                                    hidden
                                    id="uploadSignatureDialog"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;

                                        // Save file to state
                                        setSelectedFiles((prev) => ({ ...prev, signaturePhoto: file }));

                                        // Create preview
                                        const reader = new FileReader();
                                        reader.onload = () => setPreviewUrls((prev) => ({ ...prev, signaturePhoto: reader.result }));
                                        reader.readAsDataURL(file);

                                        // Clear canvas if file is uploaded
                                        signaturePadRef.current.clear();
                                    }}
                                />
                                <label htmlFor="uploadSignatureDialog">
                                    <MDButton component="span" variant="outlined" color="primary">
                                        Upload from Device
                                    </MDButton>
                                </label>

                                {/* Clear Canvas Button */}
                                <MDButton color="error" onClick={() => {
                                    signaturePadRef.current.clear();
                                    setPreviewUrls((prev) => ({ ...prev, signaturePhoto: null }));
                                    setSelectedFiles((prev) => ({ ...prev, signaturePhoto: null }));
                                }}>
                                    Clear
                                </MDButton>
                            </Box>
                        </DialogContent>

                        <DialogActions>
                            <MDButton
                                color="primary"
                                onClick={() => {
                                    let blob;

                                    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
                                        // User drew a signature on the canvas
                                        const dataUrl = signaturePadRef.current.toDataURL("image/png");
                                        blob = dataURLtoBlob(dataUrl);
                                        setPreviewUrls((prev) => ({ ...prev, signaturePhoto: dataUrl }));
                                    } else if (selectedFiles.signaturePhoto) {
                                        // User uploaded a file
                                        blob = selectedFiles.signaturePhoto;
                                    } else {
                                        setSnackbar({ open: true, message: "Please draw a signature or upload a file.", severity: "warning" });
                                        return;
                                    }

                                    setSelectedFiles((prev) => ({ ...prev, signaturePhoto: blob }));
                                    setSignatureDialogOpen(false);
                                }}
                            >
                                Save
                            </MDButton>

                        </DialogActions>
                    </Dialog>


                </Grid>
            </MDBox>

            {/* General Snackbar for various messages */}
            {/* This Snackbar is for general messages, not the 100% completion notification */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MuiAlert elevation={6} variant="filled" severity={snackbar.severity}>
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>

            {/* Confirmation Dialog for image deletion */}
            <Dialog
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        Are you sure you want to remove this image? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenDeleteDialog(false)} color="primary">
                        Cancel
                    </MDButton>
                    <MDButton
                        onClick={() => {
                            handleRemoveFile(deleteIndex);
                            setOpenDeleteDialog(false);
                        }}
                        color="error"
                        autoFocus
                    >
                        Delete
                    </MDButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
};

export default VendorUserProfile;